/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/EndpointOAuthHelper" />
import * as DelayedFunction from "DistributedTask/Common/AadAuthorizer/DelayedFunction";
import * as Contracts from "DistributedTask/ConnectedService/Client/Contracts/ConnectedService";
import * as ConnectedService from "DistributedTask/ConnectedService/Client/RestClient/ConnectedService";
import { IVssPageContext } from "VSS/Platform/Context";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { getTFSPageData } from "Tfs/Platform/Page";
import * as Resources from "DistributedTaskUI/ServiceEndpoints/Editor/Resources";
import * as ServiceEndpointsConstants from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import * as Constants from "DistributedTaskUI/ServiceEndpoints/Editor/Constants";
import * as Utils_String from "VSS/Core/Util/String";

export interface AuthRequestWindowInformation {
    accessTokenKey: string;
    ownerlogin: string;
    imageUrl: string;
}

export class EndpointOAuthHelper {
    constructor(private _pageContext: IVssPageContext) {
        this._oauthConnectedService = ConnectedService.getConnectedServiceClient(_pageContext);
        const tfsPageData = getTFSPageData(this._pageContext);
        if (tfsPageData && tfsPageData.project) {
            this._projectName = tfsPageData.project.name;
        }
    }

    public createAuthRequest(endpoint: ServiceEndpoint, userName: string, provider: string, configurationId: string, authRequest: Contracts.AuthRequest): Promise<ServiceEndpoint> {
        // Method has side-effects on `endpoint` input parameter
        return new Promise((resolve, reject) => {
            this._oauthConnectedService.createAuthRequest(authRequest, this._projectName, provider, configurationId, "", "", endpoint.type).then((authRequest: Contracts.AuthRequest) => {
                this._authRequestWindow = window.open(authRequest.url, "", "width = 960, height = 600, location = true, menubar = false, toolbar = false");
                this._pollAuthRequestWindow().then((_authRequestWindowInformation: AuthRequestWindowInformation) => {
                    // Auth
                    endpoint.authorization.parameters[Constants.AccessToken] = _authRequestWindowInformation.accessTokenKey;
                    if (Utils_String.equals(endpoint.type, ServiceEndpointsConstants.ServiceEndpointTypes.Bitbucket, true)) {
                        endpoint.authorization.parameters[Constants.Username] = undefined;
                        endpoint.authorization.parameters[Constants.Password] = undefined;
                        if (endpoint.data.displayName === null && _authRequestWindowInformation.ownerlogin) {
                            endpoint.data.displayName = (_authRequestWindowInformation.ownerlogin);
                        }
                    }

                    // Avatar
                    if (_authRequestWindowInformation.imageUrl) {
                        endpoint.data.AvatarUrl = _authRequestWindowInformation.imageUrl;
                    }

                    if (endpoint.name) {
                        resolve(endpoint);
                    }

                    let name = "";
                    if (_authRequestWindowInformation.ownerlogin) {
                        name = _authRequestWindowInformation.ownerlogin;
                    }
                    else {
                        name = new Date().toISOString();
                    }

                    if (userName) {
                        name = userName + name;
                    }
                    endpoint.name = name;
                    resolve(endpoint);
                }, (error) => {
                    reject(error);
                });

            });
        });
    }

    private _pollAuthRequestWindow(): Promise<AuthRequestWindowInformation> {
        return new Promise((resolve, reject) => {
            this._monitorAuthProgress = new DelayedFunction.DelayedFunction(this, 500, "monitorAuthProgress", () => {

                try {
                    if (!this._authRequestWindow) {
                        reject(Resources.CouldNotCompleteOAuth);
                        this._cleanupAuthRequestWindow();
                    } else if (this._authRequestWindow.closed) {
                        reject(""); // not showing any message as closing window is not an error condition
                        this._cleanupAuthRequestWindow();
                    } else {
                        try {
                            if (this._authRequestWindow.oauthcompleted) {
                                if (this._authRequestWindow.oautherrormessage) {
                                    reject(Resources.CouldNotCompleteOAuth);
                                } else if (this._authRequestWindow.strongboxkey) {
                                    const _authRequestWindowInformation: AuthRequestWindowInformation = {
                                        accessTokenKey: this._authRequestWindow.strongboxkey,
                                        ownerlogin: this._authRequestWindow.ownerlogin,
                                        imageUrl: this._authRequestWindow.owneravatarurl
                                    };
                                    resolve(_authRequestWindowInformation);
                                } else {
                                    reject(Resources.CouldNotCompleteOAuth);
                                }

                                this._cleanupAuthRequestWindow();

                            } else {
                                this._monitorAuthProgress.reset();
                            }
                        } catch (e) {
                            this._monitorAuthProgress.reset();
                        }
                    }
                } catch (e) {
                    reject(e);
                    this._cleanupAuthRequestWindow();
                }
            });
            this._monitorAuthProgress.start();
        });
    }

    // Close auth window and stop checking for tokens or window closing
    private _cleanupAuthRequestWindow() {
        if (this._authRequestWindow) {
            try {
                this._authRequestWindow.close();
                this._authRequestWindow = null;
            } catch (e) {
                // ignore
            }
        }

        if (this._monitorAuthProgress) {
            this._monitorAuthProgress.cancel();
            delete this._monitorAuthProgress;
        }
    }
    private _authRequestWindow: any;
    private _monitorAuthProgress: DelayedFunction.DelayedFunction = null;
    private _oauthConnectedService: ConnectedService.IConnectedServiceRestClient;
    private _projectName: string;
}
